export default async function GetProjectExpenseByProject(id) {
    let url = window.RealestateService+  `/api/ExpenseDetails/GetExpenseDetailsByProject?projectId=${id}`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}